const SelectField = ({label, name, value, options, onChange, minWidth = '120px', placeholder = 'Please select', wrapperClass = 'col-md-6'}) => {
  return (
    <>
     {label && <label className='fw-bold me-2 mt-3' style={{fontSize: '18px', minWidth}}>
        {label} :
      </label>}
      <select className='createTime fw-bold show' name={name} value={value} onChange={onChange} style={{fontSize: '18px'}}>
        <option value='' selected disabled>
          {placeholder}
        </option>
        {options.map(opt => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </>
  );
};

export default SelectField;
